module.exports = __webpack_public_path__ + "static/media/ORANGE BOX.873149ca.png";